import { render, staticRenderFns } from "./PrimaryDataCollectionForm.vue?vue&type=template&id=766e998a&scoped=true"
import script from "./PrimaryDataCollectionForm.vue?vue&type=script&lang=js"
export * from "./PrimaryDataCollectionForm.vue?vue&type=script&lang=js"
import style0 from "./PrimaryDataCollectionForm.vue?vue&type=style&index=0&id=766e998a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "766e998a",
  null
  
)

export default component.exports